"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _TextButton = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextButton");

var _TextButton2 = _interopRequireDefault(_TextButton);

var _SwitchPlans = require("./SwitchPlans.scss");

var _SwitchPlans2 = _interopRequireDefault(_SwitchPlans);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwitchPlans = function (_React$Component) {
  (0, _inherits3.default)(SwitchPlans, _React$Component);

  function SwitchPlans() {
    (0, _classCallCheck3.default)(this, SwitchPlans);
    return (0, _possibleConstructorReturn3.default)(this, (SwitchPlans.__proto__ || (0, _getPrototypeOf2.default)(SwitchPlans)).apply(this, arguments));
  }

  (0, _createClass3.default)(SwitchPlans, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          hasActiveLegacySubscription = _props.hasActiveLegacySubscription,
          isEpicLogin = _props.isEpicLogin,
          hasUnrealLicense = _props.hasUnrealLicense;


      return _react2.default.createElement(
        "div",
        null,
        hasActiveLegacySubscription && isEpicLogin && !hasUnrealLicense ? _react2.default.createElement(
          "div",
          { className: _SwitchPlans2.default.wrap },
          _react2.default.createElement(
            "p",
            null,
            "Choose one of our great new plans to switch to."
          ),
          _react2.default.createElement(_Button2.default, { to: "/pricing", small: true, mode: "secondary", label: "Switch Plans" })
        ) : hasActiveLegacySubscription ? _react2.default.createElement(
          "div",
          { className: _SwitchPlans2.default.wrap },
          _react2.default.createElement(
            "p",
            null,
            "If you\u2019d like to use Megascans with other tools also, choose one of our great new plans to switch to."
          ),
          !isEpicLogin ? _react2.default.createElement(_Button2.default, {
            to: "/pricing",
            small: true,
            mode: "secondary",
            label: "Switch Plans"
          }) : _react2.default.createElement(_TextButton2.default, {
            to: "/pricing",
            small: true,
            mode: "primary",
            label: "Switch Plans"
          })
        ) : _react2.default.createElement(
          "div",
          { className: _SwitchPlans2.default.wrap },
          _react2.default.createElement(
            "p",
            null,
            "If you\u2019d like to use Megascans with other tools also, choose one of our great new plans to switch to."
          ),
          _react2.default.createElement(
            "div",
            { className: _SwitchPlans2.default.buttonWrap },
            _react2.default.createElement(_TextButton2.default, { to: "/pricing", label: "Subscribe Now" })
          )
        )
      );
    }
  }]);
  return SwitchPlans;
}(_react2.default.Component);

exports.default = SwitchPlans;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/SwitchPlans.jsx
// module id = 2630
// module chunks = 0